module.exports = __webpack_public_path__ + "static/iconinfo-6c7a42a33a93fdf4cbc397c09ca84f5e.png";